//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { CommonHelper } from '../../helpers/common-helper'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'

import { OpChangeState, Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'
import { OpDistributor } from '../core/op-distributor'

import { OpReportData } from '../dw/op-report-data'
import { OpReportParam } from '../dw/op-report-param'
import { OpReportType } from '../dw/op-report-type'

import { IOpObject, IReferenceType, IOpChangeState, IOpData } from '../util/interfaces'
import { OpDataList } from '../util/op-data-list'

export class OpReport implements IReferenceType, IOpObject, IOpChangeState {

    // Properties

    public idReport: number
    public idReportType: number
    public idDistributor: number

    public get name(): string {
        return this.dataList.getValue(Enums.DataType.REPORT_NAME)
    }

    public set name(value: string) {
        this.dataList.setValue(value, Enums.DataType.REPORT_NAME)
    }

    // Properties End


    // NavigationProperties 

    public reportType: OpReportType
    public distributor: OpDistributor

    // NavigationProperties End


    // Custom Properties

    public paramsList: OpReportParam[] = []

    // Custom Properties End

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }


    //IOpChangeState Implementation

    public opState: Enums.OpChangeState

    //IOpChangeState Implementation End


    //IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdReport
    }
    public getReferenceKey(): number {
        return this.idReport
    }
    public getReferenceValue(): any {
        return this
    }

    //IReferenceType implementation end


    //IOpObject implementation
    public get idObject(): number {
        return this.idReport
    }

    public set idObject(value: number) {
        this.idReport = value
    }

    public dataList: OpDataList<OpReportData> = new OpDataList<OpReportData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string


    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idReport = opObj.ID_REPORT
            this.idReportType = opObj.ID_REPORT_TYPE
            this.idDistributor = opObj.ID_DISTRIBUTOR

            if (opObj._ReportType) {
                this.reportType = new OpReportType(opObj._ReportType)
            }

            if (opObj._Distributor) {
                this.distributor = new OpDistributor(opObj._Distributor)
            }

            if (opObj.DataList) {
                this.dataList.push(...opObj.DataList.map((data: any) => new OpReportData(data)))
            }

            if (opObj.ParamsList) {
                this.paramsList.push(...opObj.ParamsList.map((data: any) => new OpReportParam(data)))
            }

            this.dynamicValues = opObj.dynamicValues

            this.opState = opObj.OpState
        } else {
            this.idReport = 0
            this.opState = OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_REPORT: this.idReport,
            ID_REPORT_TYPE: this.idReportType,
            DataList: this.dataList.ToJSON(),
            ParamsList: this.paramsList != null ? this.paramsList.map((param: OpReportParam) => param.toJSON()) : [],
            OpState: this.opState
        }
    }

    public toString() {
        return this.name
    }
    //IOpObject implementation end

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpReport[]): JQueryPromise<OpReport[]> {
        var defered = $.Deferred<OpReport[]>()

        if (dataProvider && list && list.length > 0) {
            var idDataType: number[] = CommonHelper.getIdDataTypesFromObjectList<OpReport>(list)
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType, Enums.ReferenceType.IdReportType]).then(dict => {
                var dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)
                var reportTypeDict: Dictionary<OpReportType> = new Dictionary<OpReportType>(null)
                if (dict.containsKey(Enums.ReferenceType.IdDataType)) {
                    dataTypeDict = <Dictionary<OpDataType>>dict.tryGetValue(Enums.ReferenceType.IdDataType)
                }
                if (dict.containsKey(Enums.ReferenceType.IdReportType)) {
                    reportTypeDict = <Dictionary<OpReportType>>dict.tryGetValue(Enums.ReferenceType.IdReportType)
                }

                list.forEach(item => {
                    if (item.dataList) {
                        item.dataList
                            .toArray()
                            .forEach((data: OpReportData) => {
                                data.dataType = dataTypeDict.tryGetValue(data.idDataType)
                            })
                    }
                    if (reportTypeDict.containsKey(item.idReportType))
                        item.reportType = reportTypeDict.tryGetValue(item.idReportType)
                })
                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }
        return defered.promise()
    }

    public static fromIOpObject(object: IOpObject): OpReport {
        const newObject: OpReport = new OpReport(null)

        newObject.idReport = object.idObject
        newObject.opState = object.opState
        newObject.dataList.push(...object.dataList.toArray().map((data: IOpData) => OpReportData.fromIOpData(data)))

        return newObject
    }
}